export default __webpack_public_path__ + "4f1dc17c20de75f050f93e07caf82cc0.png";